import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

interface Props {
  work: Work;
}

export default function WorkCard({ work }: Props) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/work/${work.id}`} className="relative block overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} - 火影同人动漫封面`}
          title={`${work.title} 火影同人动漫`}
          className="aspect-[5/6] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            work.status === "连载中" ? "bg-primary-500" : "bg-secondary-500"
          }`}
        >
          {work.status}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-background-950/60 px-2 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {work.chapters}话
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <Link
          to={`/work/${work.id}`}
          className="font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-700 md:text-base"
        >
          {work.title}
        </Link>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
          {work.summary}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {work.tags.slice(0, 3).map((t) => (
            <span
              key={t}
              className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500"
            >
              {t}
            </span>
          ))}
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-secondary-500" />
            {(work.heat / 1000).toFixed(1)}k
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {(work.views / 10000).toFixed(1)}w
          </span>
          <span className="flex items-center gap-1 font-medium text-accent-600">
            <i className="ri-star-fill" />
            {work.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </article>
  );
}